"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useReplaceTextWithTranslations = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
// Change an element textContent if it is not set to textContent param value
const replaceTextContent = (querySelector, textContent)=>{
    const elements = [
        ...document.querySelectorAll(querySelector)
    ];
    elements.forEach((element)=>{
        if (element.textContent !== textContent) {
            // eslint-disable-next-line no-param-reassign -- no other suitable option
            element.textContent = textContent;
        }
    });
};
// change an element attribute if it is not set to attributeValue param value
const replaceAttribute = (querySelector, attributeName, attributeValue)=>{
    const elements = [
        ...document.querySelectorAll(querySelector)
    ];
    elements.forEach((element)=>{
        if (element.getAttribute(attributeName) !== attributeValue) {
            element.setAttribute(attributeName, attributeValue);
        }
    });
};
/**
 * Hook to replace genesys texts with translations from Poeditor.
 * This due to limited number of languages provided by Genesys.
 * Hook observes changes in #genesys-support-center div and replaces texts with translations if they are not already set.
 */ const useReplaceTextWithTranslations = (ref)=>{
    const { translations } = (0, _hooks.useTranslations)();
    (0, _react.useEffect)(()=>{
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.type === 'childList') {
                    // Placeholder in search input
                    replaceAttribute('[class*=SearchField_searchField_]', 'placeholder', translations.searchInSupportCenter);
                    // Search icon in search input
                    replaceAttribute('[class*=SearchField_searchIcon_]', 'aria-label', translations.search);
                    // Landing page title
                    replaceTextContent('[class*=KnowledgeSearch_welcomeTitle_]', translations.hiHowCanWeHelp);
                    // Home in breadcrumbs
                    replaceTextContent('[class=breadcrumbLink]', translations.home);
                    // Title in feedback section under article
                    replaceTextContent('[class*=ArticleFeedback_heading_]', translations.articleFeedbackTitle);
                    // Positive button in feedback section under article
                    replaceAttribute('[data-testid=positive-feedback-button]', 'aria-label', translations.articleFeedbackYes);
                    replaceTextContent('[data-testid=positive-feedback-button] > span', translations.articleFeedbackYes);
                    // Negative button in feedback section under article
                    replaceAttribute('[data-testid=negative-feedback-button]', 'aria-label', translations.articleFeedbackNo);
                    replaceTextContent('[data-testid=negative-feedback-button] > span', translations.articleFeedbackNo);
                    // Title of textarea input in dialog after click on negative feedback button in feedback section under article
                    replaceTextContent('label[class*=ArticleFeedback_title_]', translations.howCanWeImproveThisArticle);
                    // Submit button in dialog after click on negative feedback button in feedback section under article
                    replaceAttribute('[data-testid=negative-submit-button]', 'aria-label', translations.submit);
                    replaceTextContent('[data-testid=negative-submit-button] > span', translations.submit);
                    // Title of radio input in dialog after click on negative feedback button in feedback section under article
                    replaceTextContent('legend[class*=ArticleFeedback_title_]', translations.whatWasTheIssue);
                    // Label for the first option of the radio input
                    replaceTextContent('label[for=DocumentContent]', translations.contentMissing);
                    // Label for the second option of the radio input
                    replaceTextContent('label[for=SearchResults]', translations.contentNotRelevant);
                    // Title in info box in empty category page
                    replaceTextContent('h1[class*=CategoryEmpty_categoryEmptyTextHeader_]', translations.emptyCategoryTitle);
                    // Description in info box in empty category page
                    replaceTextContent('p[class*=CategoryEmpty_categoryEmptyTextParagraph_]', translations.emptyCategoryDescription);
                    // Title in info box in category page with an error
                    replaceTextContent('[class*=ErrorCard_container_] > p', translations.somethingWentWrong);
                    // Title in loader
                    replaceTextContent('[class*=Loaders_container_ciiyu] > p', translations.loading);
                }
            });
        });
        const observe = ()=>{
            if (ref.current) {
                observer.observe(ref.current, {
                    childList: true,
                    subtree: true
                });
            }
        };
        observe();
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        translations.articleFeedbackNo,
        translations.articleFeedbackTitle,
        translations.articleFeedbackYes,
        translations.contentMissing,
        translations.contentNotRelevant,
        translations.emptyCategoryDescription,
        translations.emptyCategoryTitle,
        translations.hiHowCanWeHelp,
        translations.home,
        translations.howCanWeImproveThisArticle,
        translations.loading,
        translations.search,
        translations.searchInSupportCenter,
        translations.somethingWentWrong,
        translations.submit,
        translations.whatWasTheIssue
    ]);
};
exports.useReplaceTextWithTranslations = useReplaceTextWithTranslations;
